module.exports = __webpack_public_path__ + "img/japan.ba3e17a1.svg";